module.exports = __webpack_public_path__ + "img/ir.da2d2d93.svg";